import { SidebarCol } from "../../chatMain/Sidebar/Sidebar";
import { MainPage} from "./MainReportPage"
//import "./Physical-Assessment.css";
import "./PEARLIReports.css"
import React, { useEffect } from 'react';
import { useDispatch } from "react-redux";
import { clearAssessmentId } from "../../../store/authSlice.js";

export const PEARLIReports = () => {
  const dispatch = useDispatch();

  /**
   * Clear assessmentId from Redux and localStorage when user lands on reports page
   * This ensures that if the user clicks "Retake Assessment", a new assessment
   * will be created instead of reusing the old one
   */
  useEffect(() => {
    dispatch(clearAssessmentId());
  }, [dispatch]);

  return (
    <div className="report-dashboard">
      <link href='https://fonts.googleapis.com/css?family=Inter' rel='stylesheet'/>
      <div className="sidebar">
        <SidebarCol />
      </div>
      <div className="maincontentarea">
        <MainPage />
      </div>
    </div>
  );
};



/*
export function PEARLIReports() {    
    return <div className="PEARLIDisplay">
      <Chart scores={[2.5,5.0,2.3,4.65,4.3,1.2]} />
      </div>
  } 

*/
